export default "__VITE_ASSET__047db937__"